import dayjs from 'dayjs';

const groupHashMap = {
    group: 'Сообщество',
    supergroup: 'Супергруппа',
    channel: 'Канал',
};
export const getColumns = () => [
    {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        width: '66px',
        render: text => text,
    },
    {
        title: 'Название сообщества',
        dataIndex: 'title',
        key: 'id',
        width: '184px',
        ellipsis: true,
        render: text => text,
    },
    {
        title: 'Владелец',
        dataIndex: 'owner_name',
        key: 'id',
        width: '184px',
        ellipsis: true,
        render: text => text,
    },
    {
        title: 'Тип',
        dataIndex: 'telegram',
        key: 'id',
        width: '161px',
        ellipsis: true,
        render: text => groupHashMap[text] || text,
    },
    {
        title: 'Подключение',
        dataIndex: 'created_at',
        key: 'id',
        width: '184px',
        ellipsis: true,
        render: time => dayjs.unix(time).format('DD.MM.YY HH:mm'),
    },
    {
        title: 'Подписчиков',
        dataIndex: 'followers',
        key: 'id',
        width: '161px',
        ellipsis: true,
        align: 'right',
        render: text => text || 0,
    },
    {
        title: 'Сумма поступлений',
        dataIndex: 'balance',
        key: 'id',
        width: '184px',
        ellipsis: true,
        align: 'right',
        render: text => text || 0,
    },
];
